import { InlineLink, Typography } from '@fullstory/components';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const APIEventTooltipContent = (
  <Typography variant="body3">
    <FormattedMessage
      defaultMessage="Use the Custom Events API to capture custom instrumented events on top of your rich Fullstory data."
      id="IS2Nad"
    />{' '}
    <InlineLink href="https://help.fullstory.com/hc/en-us/articles/360020623274" newTab>
      <FormattedMessage defaultMessage="Learn more" id="TdTXXf" />
    </InlineLink>
  </Typography>
);
